import { EnqueueSnackbar } from "notistack";

export const handleCopy = async (
  text: string,
  enqueueSnackbar: EnqueueSnackbar,
  successMessage: string
) => {
  try {
    await navigator.clipboard.writeText(text);
    enqueueSnackbar(successMessage + " copied to clipboard", {
      variant: "success",
      autoHideDuration: 2000,
    });
  } catch (err) {
    console.error("Failed to copy email to clipboard", err);
  }
};
